module.exports = __webpack_public_path__ + "18a07b3.worker.js"